<template>
  <div>
    <el-form ref="formRef" :model="letterForm" label-width="88px">
      <el-form-item label="情书标题：">
        <el-input v-model="letterForm.title" placeholder="第几封" style="width:26em;"/>
      </el-form-item>
      <el-form-item label="情书内容：">
        <el-input :rows="4" type="textarea" v-model="letterForm.msg" placeholder="300字以内" style="width:26em;"/>
      </el-form-item>
      <el-form-item label="作者：">
        <el-input v-model="letterForm.nickName" placeholder="10字以内" style="width:26em;"/>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 26em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年龄：">
        <el-date-picker
            v-model="birthday"
            type="date"
            placeholder="Pick a day"
            :shortcuts="shortcuts_d"
            style="width: 26em"
        />
      </el-form-item>
      <el-form-item label="城市：">
        <el-input v-model="letterForm.city" placeholder="请输入城市" style="width:26em;"/>
      </el-form-item>
      <el-form-item label="发表时间：">
        <el-date-picker
            v-model="showTime"
            type="datetime"
            placeholder="Pick a day"
            :shortcuts="shortcuts_t"
            style="width: 26em"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateLoveLetter } from "@/api/url";

export default {
  name: "LetterUpdateDialog",
  props: {
    value: Object
  },
  data() {
    return {
      letterForm: this.value.letterForm,
      idx: this.value.ids,
      loading: false,

      birthday: new Date(this.value.letterForm.birthday?this.value.letterForm.birthday:'1990-01-01'),
      showTime: this.value.letterForm.showTime?new Date(this.value.letterForm.showTime):new Date(),

      sexArray: [
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.letterForm.sex?this.value.letterForm.sex:1,


      shortcuts_d: [
        {
          text: '18岁',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365 * 18);
            return date
          },
        },
        {
          text: '20岁',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365 * 20);
            return date
          },
        },
        {
          text: '22岁',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365 * 22);
            return date
          },
        },
        {
          text: '25岁',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365 * 25);
            return date
          },
        },
        {
          text: '30岁',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365 * 30);
            return date
          },
        },
        {
          text: '40岁',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365 * 40);
            return date
          },
        },
      ],

      shortcuts_t: [
        {
          text: '今天',
          value: new Date(),
        },
        {
          text: '明天',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            return date
          },
        },
        {
          text: '后天',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
            return date
          },
        },
        {
          text: '一周后',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            return date
          },
        },
      ]

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    check() {
      if(!this.letterForm.title) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入情书标题',
          type: 'warning'
        });
        return false;
      }
      if(!this.letterForm.msg) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入情书内容',
          type: 'warning'
        });
        return false;
      }
      if(!this.letterForm.nickName) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入作者昵称',
          type: 'warning'
        });
        return false;
      }
      if(!this.letterForm.city) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入作者城市',
          type: 'warning'
        });
        return false;
      }
      return true;
    },

    summit() {
      if(this.check()) {
        this.loading = true
        let param = {};
        param['id'] = this.letterForm.id?this.letterForm.id:0;
        param['title'] = this.letterForm.title;
        param['msg'] = this.letterForm.msg;
        param['nickName'] = this.letterForm.nickName;
        param['city'] = this.letterForm.city;
        param['sex'] = this.sex;
        param['birthday'] = this.birthday;
        param['startExpire'] = new Date(this.showTime).getTime();
        postFormData(addOrUpdateLoveLetter, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm')
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
          this.loading = false
        }).catch(()=>{
          this.loading = false
        })
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
